import styles from './FeedFilters.module.css';

interface FilterOption {
    label: string;
    value: string;
}

const FILTERS: FilterOption[] = [
    { label: 'Tendencia', value: '-hot_score' },
    { label: 'Recientes', value: '-created' },
    { label: 'Mas votadas', value: '-total_votes' },
];

type TypeFilter = 'all' | 'poll' | 'quiz' | 'form';

interface FeedFiltersProps {
    activeFilter: string;
    onFilterChange: (value: string) => void;
    showMyVotes?: boolean;
    isMyVotesActive?: boolean;
    onMyVotesToggle?: () => void;
    activeType?: TypeFilter;
    onTypeChange?: (value: TypeFilter) => void;
}

export function FeedFilters({
    activeFilter,
    onFilterChange,
    showMyVotes = false,
    isMyVotesActive = false,
    onMyVotesToggle,
    activeType = 'all',
    onTypeChange,
}: FeedFiltersProps) {
    return (
        <div className={styles.container}>
            <div className={styles.row}>
                <div className={styles.pills}>
                    {FILTERS.map((filter) => (
                        <button
                            key={filter.value}
                            className={`${styles.pill} ${activeFilter === filter.value && !isMyVotesActive ? styles.active : ''}`}
                            onClick={() => onFilterChange(filter.value)}
                            type="button"
                        >
                            {filter.label}
                        </button>
                    ))}
                    {showMyVotes && onMyVotesToggle && (
                        <button
                            className={`${styles.pill} ${isMyVotesActive ? styles.active : ''}`}
                            onClick={onMyVotesToggle}
                            type="button"
                        >
                            Mis votos
                        </button>
                    )}
                </div>

                {onTypeChange && (
                    <>
                        <div className={styles.divider} />
                        <div className={styles.pills}>
                            <button
                                className={`${styles.pill} ${styles.typePill} ${activeType === 'all' ? styles.active : ''}`}
                                onClick={() => onTypeChange('all')}
                                type="button"
                            >
                                Todo
                            </button>
                            <button
                                className={`${styles.pill} ${styles.typePill} ${activeType === 'poll' ? styles.active : ''}`}
                                onClick={() => onTypeChange('poll')}
                                type="button"
                            >
                                Encuestas
                            </button>
                            <button
                                className={`${styles.pill} ${styles.typePill} ${activeType === 'quiz' ? styles.active : ''}`}
                                onClick={() => onTypeChange('quiz')}
                                type="button"
                            >
                                Trivia
                            </button>
                            <button
                                className={`${styles.pill} ${styles.typePill} ${activeType === 'form' ? styles.active : ''}`}
                                onClick={() => onTypeChange('form')}
                                type="button"
                            >
                                Formularios
                            </button>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
}

export type { TypeFilter };
